var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2077_28252)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2077_28252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2077_28252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 17.7087H5.83073C2.78906 17.7087 1.03906 15.9587 1.03906 12.917V7.08366C1.03906 4.04199 2.78906 2.29199 5.83073 2.29199H14.1641C17.2057 2.29199 18.9557 4.04199 18.9557 7.08366V12.917C18.9557 15.9587 17.2057 17.7087 14.1641 17.7087ZM5.83073 3.54199C3.4474 3.54199 2.28906 4.70033 2.28906 7.08366V12.917C2.28906 15.3003 3.4474 16.4587 5.83073 16.4587H14.1641C16.5474 16.4587 17.7057 15.3003 17.7057 12.917V7.08366C17.7057 4.70033 16.5474 3.54199 14.1641 3.54199H5.83073Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99707 10.725C9.29707 10.725 8.58873 10.5083 8.04705 10.0667L5.43872 7.98331C5.17205 7.76664 5.12205 7.37498 5.33872 7.10831C5.55538 6.84164 5.94705 6.79164 6.21372 7.00831L8.82207 9.09167C9.4554 9.6 10.5304 9.6 11.1637 9.09167L13.7721 7.00831C14.0387 6.79164 14.4387 6.83331 14.6471 7.10831C14.8637 7.37498 14.8221 7.77498 14.5471 7.98331L11.9387 10.0667C11.4054 10.5083 10.6971 10.725 9.99707 10.725Z",
    fill: "#5A5A5A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2077_28252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0bce9ff0f1483f4cb222f09aa8b2360d.svg";
export { ForwardRef as ReactComponent };